module.exports = __webpack_public_path__ + "img/Dantam Hair 12.1d5f82c4.jpg";